import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsCardModel from './pcs-card.ts';

export default class PcsAuthorizationModel extends Model {
  @attr declare state: string;
  @attr declare provider: string;
  @attr declare providerId: string;
  @attr declare amount: number;
  @attr declare providerData: Record<string, unknown>;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('pcs-card', { async: false, inverse: 'pcsAuthorizations' })
  declare pcsCard: PcsCardModel;

  [Type] = 'pcs-authorization' as const;
}
